export const actionTypes = {
  GLOBAL_RESET: 'app/global-reset',
};
